import { render, staticRenderFns } from "./DependenciesItem.vue?vue&type=template&id=a8ef1dec&scoped=true&"
import script from "./DependenciesItem.vue?vue&type=script&lang=js&"
export * from "./DependenciesItem.vue?vue&type=script&lang=js&"
import style0 from "./DependenciesItem.vue?vue&type=style&index=0&id=a8ef1dec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ef1dec",
  null
  
)

export default component.exports